import React from "react";
import TableUtility from "../../../Common/UtilityCommon/TableUtility";

const TransferAdjustmentUtility = () => {
   const apiUrl = `${process.env.REACT_APP_API}/getall-Transfer`;
   const columns = [
      { label: "Company Name", key: "Company_Name_E" },
      { label: "To Ac Name", key: "ToACName" },
      { label: "From Ac Name", key: "FromACName" },
      { label: "Cross Company Name", key: "CrossCompanyName" },
      { label: "Cross To Ac Name", key: "CrossToACName" },
      { label: "Cross From Ac Name", key: "CrossFromAcc" },
   ];
   return (
      <TableUtility
         title="Transfer Adjustment"
         apiUrl={apiUrl}
         columns={columns}
         rowKey="Id"
         addUrl="/TransferAdj"
         detailUrl="/TransferAdj"
         permissionUrl="/TransferAdjutility"
      // includeYearCode = {includeYearCode}

      />
   );

};

export default TransferAdjustmentUtility;